import React from "react";
import { STATUS_FILTERS } from "util/manualDeliveryStatus";
import DateRangeButton from "./DateRangeButton";

export default function DeliveryFilters({
  query,
  onQuery,
  status,
  onStatus,
  range,
  onRange,
  visibleCount,
  onExport,
  exporting,
}) {
  return (
    <div className="md-filters">
      <input
        type="search"
        className="md-input md-filters__search"
        aria-label="Search deliveries"
        placeholder="Search name, address or notes"
        value={query}
        onChange={(event) => onQuery(event.target.value)}
      />
      <select
        className="md-select"
        aria-label="Status"
        value={status}
        onChange={(event) => onStatus(event.target.value)}
      >
        {STATUS_FILTERS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <DateRangeButton range={range} onChange={onRange} />
      <button type="button" className="md-btn" onClick={onExport} disabled={visibleCount === 0 || exporting}>
        {`Export ${visibleCount} as CSV`}
      </button>
    </div>
  );
}
